import { MS_PAYMENTS_URL } from "../../env"
import { getTenant } from "../../utils/getTenant"
import { getSession } from "../auth/getSession"

type SubscriptionCancelPayload = {
  memberId: string
}

export const subscriptionCancel = async (
  payload: SubscriptionCancelPayload
) => {
  const { memberId } = payload
  const { access_token } = await getSession()

  const tenant = getTenant()

  const url = new URL(`${MS_PAYMENTS_URL}/cancel/${tenant}`)
  url.searchParams.set("memberId", memberId)

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json"
    }
  })

  if (!response.ok) throw new Error("Error canceling subscription")
}
